import { roleNames } from 'constants/role.const';

export const isVendor = (roleName) => roleNames.vendor === roleName;
export const isAdmin = (roleName) => roleNames.admin === roleName;
export const isSubscriber = (roleName) => roleNames.subscriber === roleName;
export const isTeamMember = (roleName) => roleNames.team_member === roleName;
export const isTeamManager = (roleName) => roleNames.team_manager === roleName;
export const isTeamManagerOrVendor = (roleName) => isTeamManager(roleName) || isVendor(roleName);
export const isTeamManagerOrMember = (roleName) => isTeamMember(roleName) || isTeamManager(roleName);
